import React, { useEffect } from 'react';
import { Spinner } from '@economic/taco';

import { useLocation } from 'react-router-dom';
import useQuery from '../../../../shared/hooks/useQuery';
import MoneyflowOnboardDialogFooter from '../../../sales/invoicing/invoices/book-and-send/moneyflow/always-on-version/MoneyflowOnboardDialogFooter';
import track from '../../../../shared/util/utilities/mixpanel';

interface Props {
    onError: () => void;
    onCancel: () => void;
}

export default function StepOnboard({ onError, onCancel }: Props) {
    const location = useLocation();
    const { campaignCallbackData } = location.state || ({} as any);

    const openedFromInvoicePage = location.pathname.includes('/sales/invoicing/invoices');
    const locationParam = `location=${openedFromInvoicePage ? 'draftInvoicePage' : 'market'}`;
    const getOnboadingUrl = campaignCallbackData
        ? `/moneyflow/company/getOnboardingUrl?campaignCallbackData=${campaignCallbackData}&${locationParam}`
        : `/moneyflow/company/getOnboardingUrl?${locationParam}`;
    const { loading: onboardingUrlLoading, data: onboardingUrl, error } = useQuery<string>(getOnboadingUrl);

    useEffect(() => {
        if (!onboardingUrlLoading && !onboardingUrl) {
            track('moneyflow', 'onboarding.blocked', {
                source: openedFromInvoicePage ? 'Sales' : 'Market',
                date: new Date(),
            });
            onError();
        }
    }, [onboardingUrlLoading]);

    const handleFrameOnLoad = e => {
        if (e.target.contentDocument) {
            const targetUrl: string = e.target.contentDocument.location.href;
            if (targetUrl.indexOf('status=close') > -1) {
                onCancel();
            }
        }
    };

    if (onboardingUrlLoading) {
        return (
            <div className="flex flex-col items-center">
                <Spinner />
            </div>
        );
    }

    if (error) {
        return <div className="moneyflow__onboarding moneyflow__onboarding__onboard_error">{error.toString()}</div>;
    }

    return (
        <>
            <div className="moneyflow__onboarding moneyflow__onboarding__content moneyflow__onboarding__onboard">
                <iframe
                    className="border-0 absolute left-0 right-0 top-0"
                    src={onboardingUrl}
                    onLoad={handleFrameOnLoad}
                    title="Moneyflow"
                />
            </div>
            <MoneyflowOnboardDialogFooter className="absolute w-[768.4px] -bottom-20" />
        </>
    );
}
